import React from 'react';
import Contact from '../components/Contact';

const NotFoundPage = () => (
  <div>
    <section className="hero is-sjs-dark-blue">
          <div className="hero-body">
            <div className="container">
              <h1 className="title">
                Not found! (404)
              </h1>
            </div>
          </div>
      </section>
    <section className="section content">
        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              Uh oh! It looks like this page doesn't exist. Please report the missing link to <a href="mailto:support@sanjuansw.com">support@sanjuansw.com</a>, Thanks!
            </div>
          </div>
        </div>
      </section>
    <Contact />
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js